export default class EventBusCustom {
    /**
     * Initialize a new event bus instance.
     */
    constructor() {
        this.bus = document.createElement('customCmsEvent');
    }

    /**
     * Add an event listener.
     */
    addEventListener(event, callback)
    {
        this.bus.addEventListener(event, callback);
    }

    /**
     * Dispatch an event.
     */
    dispatchEvent(event, detail = {})
    {
        this.bus.dispatchEvent(new CustomEvent(event, { detail: detail }));
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/util/eventBusCustom.js